import $ from 'jquery';

$('.js-newsletter-subscribe').on("submit", function (event) {
    event.preventDefault();
    const $form = $(this);
    const formValues = $form.serialize();
    $.post("/newsletter-subscribe", formValues, function () {
        $form.html('<div class="text-body p-4 py-lg-8 px-lg-9 text-center"><h3>Dank voor je aanmelding.</h3></div>');
    });
});